import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecprojectkind/cecProjectKind/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecprojectkind/cecProjectKind/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecprojectkind/cecProjectKind/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecprojectkind/cecProjectKind/list',
      method: 'get',
      params: params
    })
  },

  allList: function (params) {
    return request({
      url: '/cecprojectkind/cecProjectKind/allList',
      method: 'get',
      params: params
    })
  },

  getKindList: function (params) {
    return request({
      url: '/cecprojectkind/cecProjectKind/getKindList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecprojectkind/cecProjectKind/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecprojectkind/cecProjectKind/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecprojectkind/cecProjectKind/import',
      method: 'post',
      data: data
    })
  },
  getCecUpdateProjectKind: function (params) {
    return request({
      url: '/cecprojectkind/cecProjectKind/getCecUpdateProjectKind',
      method: 'post',
      params: params
    })
  }
}
